module.exports = __webpack_public_path__ + "18_vast.jpg?6147a3f96c675153d1506d7f796c1f31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/18_vast.jpg
// module id = 163
// module chunks = 0